export const referralLinkStyle = theme => ({
  root: {},

  card: {},

  box: {
    marginBottom: theme.spacing(2),

    '&:last-child': {
      marginBottom: 0,
    },
  },

  input: {
    flexGrow: 1,
  },

  button: {
    minWidth: 'auto',
    marginLeft: theme.spacing(),
  },

  popup: {
    padding: theme.spacing(),
  },

  code: {
    display: 'block',
  },
})
